export default function getNextState(setState) {
  return new Promise(function (resolve) {
    setState(function (preState) {
      resolve(preState);
      return preState;
    });
  });
}